import * as Yup from 'yup';

export const getValidationSchema = (isThirdPartyBillingRequired: boolean) =>
    Yup.object({
        billingRecipientName: Yup.string().required('Billing recipient name is required.').nullable(),
        billingEmail: Yup.string().email('Email is invalid.').required('Billing email is required.').nullable(),
        thirdPartyBillingId: isThirdPartyBillingRequired
            ? Yup.string().required('Third party is required.').nullable()
            : Yup.string().nullable(),
        billingCustomerCode: Yup.string().required('Billing customer code is required.').nullable(),
    });
